import React, { useState, useRef, useCallback } from 'react';
import { toast } from '../../utilities/appToast';

const UploadFile = ({ inputId, acceptType, onFileLoaded }) => {
  const DEFAULT_MESSAGE = "No se ha seleccionado ningún archivo";
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState(DEFAULT_MESSAGE);
  const [dragActive, setDragActive] = useState(false);
  const fileInputRef = useRef(null);

  const extensionPermitida = useCallback((selectedFile) => {
    if (!acceptType) return true;
    const allowed = acceptType.split(',').map(type => type.trim().toLowerCase().replace(".", ""));
    const currentExtension = selectedFile.name.split(".").pop().toLowerCase();
    return allowed.includes(currentExtension);
  }, [acceptType]);

  const handleFileRemove = () => {
    setFile(null)
    setFileName(DEFAULT_MESSAGE);
    onFileLoaded("");
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const applySelectedFile = (selectedFile) => {
    if (!selectedFile) {
      return handleFileRemove();
    }
    if (!extensionPermitida(selectedFile)) {
      toast.warn("La extension del archivo deberia ser: " + acceptType);
      return handleFileRemove();
    }
    setFile(selectedFile)
    setFileName(selectedFile.name);
    onFileLoaded(selectedFile);
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target?.files[0];
    if (!selectedFile) {
      return handleFileRemove();
    }
    applySelectedFile(selectedFile);
  };

  const onDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(true);
  };

  const onDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragActive(false);
  };

  const onDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    const dropped = e.dataTransfer?.files?.[0];
    if (dropped) {
      applySelectedFile(dropped);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  return (
    <div
      className="row align-items-center justify-content-center rounded p-2"
      onDragOver={onDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
      style={{
        border: dragActive ? "2px dashed var(--bs-secondary)" : "2px dashed transparent",
        transition: "border-color 0.15s ease",
      }}
    >

      <div className="col-auto position-relative">
        <label className="allow-pointer-cursor" htmlFor={inputId}>
          <img
            src="/img/upload-file.svg"
            alt="upload_file"
            title={fileName}
            className="p-2"
          />
          <input
            type="file"
            id={inputId}
            accept={acceptType}
            className="d-none"
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </label>
        <i
          title="Eliminar"
          onClick={handleFileRemove}
          hidden={!file}
          className="
            mdi mdi-close-circle 
            color-rojo-megatone 
            position-absolute top-0 end-0 p-0 
            allow-pointer-cursor 
            hover-background-color 
            rounded
          "
        />
      </div>

      <div className="col-12 text-center"><p>{fileName}</p></div>
    </div>
  )
};

export default UploadFile;